import { useCallback, useState } from 'react';
import { addDays, isAfter, isBefore, isSameDay } from 'date-fns';
import { isSelectable } from '../helpers';
/**
 * This hooks is incharge of range hover.
 * @param {boolean} range
 * @param {Date} date
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {number} numberOfMonths
 */
function useRangeHover(_ref) {
  let {
    range,
    startDate,
    endDate,
    minDate,
    maxDate
  } = _ref;
  const [stateHoveredDate, setStateHoveredDate] = useState(null);
  const onDateHover = useCallback(dateCurrentlyHovered => {
    const isEligibleForHoverCalculation = startDate && !endDate && range && dateCurrentlyHovered;
    if (!isEligibleForHoverCalculation) {
      setStateHoveredDate(null);
      return;
    }
    const isNotBlocked = isSelectable({
      minDate,
      maxDate,
      date: dateCurrentlyHovered
    }) || startDate && isSameDay(dateCurrentlyHovered, startDate);
    const isHoveredDateAfterOrEqualMinDate = minDate ? !isBefore(dateCurrentlyHovered, addDays(minDate, -1)) : true;
    const isHoveredDateBeforeOrEqualMaxDate = maxDate ? !isAfter(dateCurrentlyHovered, maxDate) : true;
    const isExactAndInRange = isHoveredDateAfterOrEqualMinDate && isHoveredDateBeforeOrEqualMaxDate;
    const isInRange = startDate && !endDate && isHoveredDateAfterOrEqualMinDate && isHoveredDateBeforeOrEqualMaxDate;
    const isStartDateHoveredAndInRange = startDate && isSameDay(dateCurrentlyHovered, startDate);
    const isAlreadyInState = stateHoveredDate && isSameDay(stateHoveredDate, dateCurrentlyHovered);
    if (!isAlreadyInState && isNotBlocked && (isExactAndInRange || isInRange || isStartDateHoveredAndInRange)) {
      setStateHoveredDate(dateCurrentlyHovered);
    } else if (!isAlreadyInState && stateHoveredDate !== null) {
      setStateHoveredDate(null);
    }
  }, [stateHoveredDate, startDate, endDate, range, minDate, maxDate]);
  return [stateHoveredDate, onDateHover];
}
export default useRangeHover;
//# sourceMappingURL=useRangeHover.js.map